import { Component, Inject, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTabGroup } from "@angular/material/tabs";
import { TranslateService } from "@ngx-translate/core";
import { Passenger } from "../../shared/models/passenger.model";
import { SharedService } from "../../shared/shared.service";
import { PassengersService } from "../passengers.service";

@Component({
    selector: "app-update-flight-assigned-passengers-dialog",
    templateUrl: "./update-flight-assigned-passengers-dialog.component.html",
    styleUrls: ["./update-flight-assigned-passengers-dialog.component.scss"],
    standalone: false,
})
export class UpdateFlightAssignedPassengersDialogComponent {
    @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;

    public passengersListFormGroup: FormGroup;
    public tabIndex = 0;
    private _passengersList: Passenger[] = [];

    constructor(
        public dialogRef: MatDialogRef<UpdateFlightAssignedPassengersDialogComponent>,
        @Inject(MAT_DIALOG_DATA)
        private _data: {
            flightId: number;
            passengerId: number;
            passengersList: Passenger[];
            tabIndex: number;
        },
        private _formnBuilder: FormBuilder,
        private _passengersService: PassengersService,
        private _snackBar: MatSnackBar,
        private _translate: TranslateService,
        private _sharedService: SharedService,
    ) {
        this._formnBuilder.group({
            passenger: this._formnBuilder.array([]),
        });
        this._passengersList = this._data.passengersList;
        const passArray = this.passengersListFormGroup.get("passenger") as FormArray;
        this._passengersList.map((p) => {
            passArray.push(
                this._formnBuilder.group({
                    id: [p.id],
                    firstName: [p.firstName, Validators.required],
                    lastName: [p.lastName, Validators.required],
                    gender: [p.gender],
                    dateOfBirth: [p.dateOfBirth],
                    idCardNumber: [p.idCardNumber],
                    nationalityId: [p.nationalityId],
                    passengerWeight: [!p.passengerWeight ? 0 : p.passengerWeight, [Validators.required, Validators.min(0)]],
                    luggageWeight: [!p.luggageWeight ? 0 : p.luggageWeight, [Validators.required, Validators.min(0)]],
                    luggageLength: [!p.luggageLength ? 0 : p.luggageLength, [Validators.required, Validators.min(0)]],
                    luggageWidth: [!p.luggageWidth ? 0 : p.luggageWidth, [Validators.required, Validators.min(0)]],
                    luggageHeight: [!p.luggageHeight ? 0 : p.luggageHeight, [Validators.required, Validators.min(0)]],
                    flightId: [this._data.flightId],
                }),
            );
        });
        this.tabIndex = this._data.tabIndex;
    }

    get formArry() {
        return this.passengersListFormGroup.get("passenger") as FormArray;
    }

    onFormSubmit() {
        if (this.passengersListFormGroup.valid) {
            this._passengersService.updatePassengersList(this.passengersListFormGroup.value.passenger).subscribe((result) => {
                this.dialogRef.close();
                this._snackBar.open(this._translate.instant("GENERAL.savedSuccessMsg"), this._translate.instant("GENERAL.close"), {
                    duration: 3000,
                });
            });
        }
    }
}
